<template>
    <div class='login-box'>
        <div class="login-box-logo">
            <img src='https://server.cottongame.com/serverstore/service/logo.png' alt=''>
            <h3>CottonGame</h3>
        </div>
        <el-form :model="ruleForm" status-icon :rules='rules' ref="ruleForm" class="login-form">
            <div v-if='stepNumber === 1'>
                <el-form-item prop='queryAccount' key='queryAccount'>
                    <el-input size='medium'
                              :placeholder="forgetContactMode === 1 ? ($t('forgetPwd.enterRecoverAccount') || '请输入找回账号') : forgetContactMode === 2 ? ($t('forgetPwd.enterPhoneQuery') || '请输入手机号查询') : ($t('forgetPwd.enterEmailQuery') || '请输入邮箱查询')"
                              v-model='ruleForm.queryAccount' />
                </el-form-item>
                <el-form-item>
                    <el-button size='medium' style='width: 100%' type='primary' @click='queryAccount'>
                        {{ $t('common.query') || '查询' }}
                    </el-button>
                </el-form-item>
            </div>
            
            <div v-if='stepNumber === 2'>
                <p style='margin-bottom: 1rem;text-align: left;'>{{ $t('forgetPwd.recoverAccount') || '找回账号' }}
                    {{ forgetAccountInfo.account }}</p>
                <el-form-item key='captcha' prop='captcha'>
                    <el-input size='medium' style='width: 65%'
                              :placeholder="$t('login.enterVerifyCode') || '请输入验证码'" v-model='ruleForm.captcha'
                              autocomplete='off'>
                        <template slot='prepend'>{{ $t('login.verifyCode') || '验证码' }}</template>
                    </el-input>
                    &nbsp;&nbsp;<el-button type='text' :disabled='captcha.sendStatus' size='medium'
                                           @click='sendCaptchaByPhoneOrAccount' style='float: right'>
                    {{ captcha.sendStatus ? `${captcha.resendTime}${$t('login.resendAfter') || '秒后重新获取'}` : $t('login.getVerifyCode') || '获取验证码' }}
                </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size='medium' style='width: 100%' type='primary' @click='submitForm'>
                        {{ $t('common.submit') || '提交' }}
                    </el-button>
                </el-form-item>
            </div>
            <div v-if='stepNumber === 3'>
                <p style='margin-bottom: 1rem;text-align: left;'>{{ $t('forgetPwd.recoverAccount') || '找回账号' }}
                    {{ forgetAccountInfo.account }}</p>
                <el-form-item key='password' prop='password'>
                    <el-input size='medium' :placeholder="$t('forgetPwd.enterNewPassword') || '请输入密码'"
                              type='password' show-password v-model='ruleForm.password' />
                </el-form-item>
                <el-form-item key='duplicatePassword' prop='duplicatePassword'>
                    <el-input size='medium' :placeholder="$t('forgetPwd.reenterPassword') || '重新输入密码'"
                              type='password' show-password v-model='ruleForm.duplicatePassword' />
                </el-form-item>
                <el-form-item>
                    <el-button size='medium' style='width: 100%' type='primary' @click='doUpdatePwd'>
                        {{ $t('common.modify') || '修改' }}
                    </el-button>
                </el-form-item>
            </div>
            <el-divider content-position='center'>{{ $t('common.or') || '或者使用以下方式' }}</el-divider>
            <el-row :gutter='10'>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('login')">{{ $t('login.accountLogin') || '账号登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('phoneLogin')">{{ $t('login.phoneLogin') || '短信登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('emailLogin')">{{ $t('login.emailLogin') || '邮箱登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click='forgetAccount'>{{ forgetContactButText }}</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { loginApi } from '@/service/api/loginApi';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'PhoneLogin',
    data() {
        let validatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterPassword') || '请输入密码'));
            } else {
                callback();
            }
        }
        
        let validateDuplicatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterPassword') || '请输入密码'));
            } else {
                if (value !== this.ruleForm.password) {
                    callback(new Error(this.$t('forgetPwd.passwordDifferent') || '两次密码不同'));
                }
                callback();
            }
        }
        return {
            ruleForm: {
                phone: undefined,
                captcha: undefined,
                account: undefined,
                password: undefined,
                duplicatePassword: undefined,
                
                queryAccount: undefined
            },
            rules: {
                password: [
                    { validator: validatePassword, trigger: 'blur' }
                ],
                duplicatePassword: [
                    { validator: validateDuplicatePassword, trigger: 'blur' }
                ],
                queryAccount: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.forgetContactMode === 1 ? (this.$t('login.enterAccount') || '请输入账号') : this.forgetContactMode === 2 ? (this.$t('login.enterPhone') || '请输入手机号') : (this.$t('login.enterEmail') || '请输入邮箱')));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ],
                captcha: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
                            }else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ]
            },
            stepNumber: 1,
            forgetContactButText: this.$t('forgetPwd.forgetAccount') || '忘记账号',
            forgetContactMode: 1,
            existPhoneStatus: false,
            captcha: {
                sendStatus: false,
                resendTime: 60,
                time: undefined,
                verifyStatus: false
            },
            forgetAccountInfo: {
                account: undefined,
                phone: undefined,
                email: undefined
            }
        };
    },
    created() {
        if (localStg.get(EnumLocalStore.jwtTokenName)) {
            this.$router.push('/')
        }
    },
    methods: {
        queryAccount() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                
                let data = {}
                if (this.forgetContactMode === 1) {
                    data.account = this.ruleForm.queryAccount
                } else if (this.forgetContactMode === 2) {
                    data.phone = this.ruleForm.queryAccount
                } else {
                    data.email = this.ruleForm.queryAccount;
                }
                accountApi.queryAccountInfoByContact(data).then(result => {
                    if (result.code === 200) {
                        this.forgetAccountInfo = result.data
                        if (!this.forgetAccountInfo.account) {
                            message.error(this.$t('forgetPwd.noUsernameSet') || '该账号未设置用户名，请登录成功之后进行设置！');
                        }
                        if (this.forgetAccountInfo.phone && this.forgetAccountInfo.phone !== '') {
                            this.stepNumber = 2
                            this.existPhoneStatus = true;
                        } else if (this.forgetAccountInfo.email && this.forgetAccountInfo.email !== '') {
                            this.stepNumber = 2;
                            this.existPhoneStatus = false;
                        }else {
                            message.error(this.$t('forgetPwd.noPhoneOrEmail') || '该账号未绑定手机或邮箱，请联系管理员找回！');
                        }
                    }
                })
            })
        },
        submitForm() {
            // 验证验证码
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                
                let data = {}
                data.captcha = this.ruleForm.captcha
                if (this.forgetContactMode === 1) {
                    data.account = this.ruleForm.queryAccount;
                } else if (this.forgetContactMode === 2) {
                    data.phone = this.ruleForm.queryAccount
                }else {
                    data.email = this.ruleForm.queryAccount;
                }
                accountApi.judgeCaptchaByContact(data).then(result => {
                    if (result.code === 200) {
                        this.captcha.verifyStatus = true
                        clearInterval(this.captcha.time)
                        this.captcha.resendTime = 60
                        this.captcha.sendStatus = false
                        this.stepNumber = 3
                    }
                })
            })
        },
        sendCaptchaByPhoneOrAccount() {
            if (this.forgetContactMode === 1) {
                if (this.existPhoneStatus) {
                    accountApi.sendPhoneCaptchaByAccount({ account: this.ruleForm.queryAccount }).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('forgetPwd.codeSentTo', { contact: this.forgetAccountInfo.phone }) || `验证码已发送至！${this.forgetAccountInfo.phone}`);
                            this.setTime();
                        }
                    });
                } else {
                    accountApi.sendEmailCaptchaByAccount({ account: this.ruleForm.queryAccount }).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('forgetPwd.codeSentTo', { contact: this.forgetAccountInfo.email }) || `验证码已发送至！${this.forgetAccountInfo.email}`);
                            this.setTime();
                        }
                    });
                }
            } else if (this.forgetContactMode === 2) {
                accountApi.sendCaptchaByPhone({ phone: this.ruleForm.queryAccount }).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('forgetPwd.codeSentTo', { contact: this.forgetAccountInfo.phone }) || `验证码已发送至！${this.forgetAccountInfo.phone}`);
                        this.setTime()
                    }
                })
            } else {
                accountApi.sendCaptchaByEmail({ email: this.ruleForm.queryAccount }).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('forgetPwd.codeSentTo', { contact: this.forgetAccountInfo.email }) || `验证码已发送至！${this.forgetAccountInfo.email}`);
                        this.setTime();
                    }
                })
            }
        },
        setTime() {
            this.captcha.sendStatus = true
            this.captcha.time = setInterval(() => {
                if (this.captcha.resendTime <= 1) {
                    clearInterval(this.captcha.time)
                    this.captcha.resendTime = 60
                    this.captcha.sendStatus = false
                }
                this.captcha.resendTime = this.captcha.resendTime - 1
            }, 1000)
        },
        skipPage(router) {
            this.$router.push(router)
        },
        forgetAccount() {
            this.forgetContactMode = this.forgetContactMode + 1;
            if (this.forgetContactMode > 3) {
                this.forgetContactMode = 1;
            }
            if (this.forgetContactMode === 1) {
                this.forgetContactButText = this.$t('forgetPwd.forgetAccount') || '忘记账号';
            } else if (this.forgetContactMode === 2) {
                this.forgetContactButText = this.$t('forgetPwd.forgetPhone') || '忘记手机号';
            } else if (this.forgetContactMode === 3) {
                this.forgetContactButText = this.$t('forgetPwd.forgetEmail') || '忘记邮箱';
            }
            this.ruleForm.queryAccount = undefined
        },
        doUpdatePwd() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                let data = {}
                data.captcha = this.ruleForm.captcha
                data.password = this.ruleForm.password
                
                if (this.existPhoneStatus) {
                    if (this.forgetContactMode === 1) {
                        data.account = this.ruleForm.queryAccount;
                    } else if (this.forgetContactMode === 2) {
                        data.phone = this.ruleForm.queryAccount;
                    }
                    
                    accountApi.updatePasswordByPhone(data).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('forgetPwd.modifySuccessLogin') || '修改成功 正在进行登录');
                            let loginData = {};
                            loginData.password = this.ruleForm.password;
                            loginData.account = this.ruleForm.queryAccount;
                            loginApi.playerLogin(loginData).then(result => {
                                if (result.code === 200) {
                                    // 进入首页
                                    let data = result.data;
                                    localStg.set(EnumLocalStore.jwtTokenName, data.token);
                                    localStg.set('account', data.data.account);
                                    localStg.set('userId', data.data.userId);
                                    localStg.set('platformId', data.data.platformId);
                                    this.$router.push('/');
                                }
                            });
                        }
                    });
                } else {
                    if (this.forgetContactMode === 1) {
                        data.account = this.ruleForm.queryAccount;
                    } else if (this.forgetContactMode === 3) {
                        data.email = this.ruleForm.queryAccount;
                    }
                    
                    accountApi.updatePasswordByEmail(data).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('forgetPwd.modifySuccessLogin') || '修改成功 正在进行登录');
                            let loginData = {};
                            loginData.password = this.ruleForm.password;
                            loginData.account = this.ruleForm.queryAccount
                            loginApi.playerLogin(loginData).then(result => {
                                if (result.code === 200) {
                                    // 进入首页
                                    let data = result.data;
                                    localStg.set(EnumLocalStore.jwtTokenName, data.token);
                                    localStg.set('account', data.data.account);
                                    localStg.set('userId', data.data.userId);
                                    localStg.set('platformId', data.data.platformId);
                                    this.$router.push('/');
                                }
                            });
                        }
                    })
                }
            })
        }
    }
});
</script>

<style lang='css'>
@import "../../assets/css/login.css";
</style>
